import { useState } from 'react'
import api from '../../api/axiosInstance'
import {
  Box,
  Paper,
  TextField,
  Typography,
  Select,
  InputLabel,
  MenuItem,
  FormControl,
  Button,
  IconButton,
  alpha,
} from '@mui/material'
import { useNavigate } from 'react-router-dom'
import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'
import { AccountCircle } from '@mui/icons-material'
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail'
import LockIcon from '@mui/icons-material/Lock'
import Swal from 'sweetalert2'

const ACCENT = '#10b981'

// standard variant alanların koyu zeminde okunur kalması için
const fieldSx = {
  '& .MuiInputBase-root': { color: '#fff' },
  '& .MuiInputLabel-root': { color: alpha('#fff', 0.6) },
  '& .MuiInputLabel-root.Mui-focused': { color: ACCENT },
  '& .MuiInput-underline:before': { borderBottomColor: alpha(ACCENT, 0.25) },
  '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
    borderBottomColor: alpha(ACCENT, 0.4),
  },
  '& .MuiInput-underline:after': { borderBottomColor: ACCENT },
  '& .MuiSvgIcon-root': { color: alpha('#fff', 0.6) },
}

const NewUser = () => {
  const [userName, setUserName] = useState()
  const [email, setEmail] = useState()
  const [password, setPassword] = useState()
  const [showPassword, setShowPassword] = useState(false)
  const [role, setRole] = useState('user')
  const navigate = useNavigate()


  const handleChange = (event) => {
    setRole(event.target.value)
    console.log(role)
  }

  const newUserHandler = async() => {
     try {
      await api.post('users/',{
        email: email,
        password: password,
        name: userName, 
        role: role
      })
      Swal.fire({
        icon: 'success',
        title: 'Başarılı oluşuturldu',
        text: 'Sisteme yeni kullanıcı eklendi !',
        confirmButtonText: 'Tamam'
      })
      navigate('/admin/users')
     } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Hatalı sonuç',
        text: error.response.data.message,
        confirmButtonText: 'Tamam'
      })
     }
  }

  const canselHandler = () => {
    navigate('/admin')
  }

  const userNameHandler = (event) => {
    setUserName(event.target.value)
    console.log(userName)
  }

  const emailHandler = (event) => {
    setEmail(event.target.value)
  }

  const passwordHandler = (event) => {
    setPassword(event.target.value)
    console.log(password)
  }

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword)
  }

  const handleMouseDownPassword = (event) => {
    event.preventDefault()
  }

  const handleMouseUpPassword = (event) => {
    event.preventDefault()
  }

  return (
    <Box>
      {/* Header */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" sx={{ fontWeight: 700, color: '#fff', mb: 0.5 }}>
          Yeni Kullanıcı Ekle
        </Typography>
        <Typography sx={{ fontSize: '0.9rem', color: alpha('#fff', 0.6) }}>
          Sisteme yeni bir hesap tanımlayın
        </Typography>
      </Box>

      <Paper
        sx={{
          maxWidth: 560,
          bgcolor: alpha('#fff', 0.03),
          backdropFilter: 'blur(20px)',
          backgroundImage: 'none',
          border: `1px solid ${alpha(ACCENT, 0.15)}`,
          borderRadius: 2.5,
          p: 3,
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
          <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 1 }}>
            <AccountCircle sx={{ color: alpha(ACCENT, 0.7), my: 0.5 }} />
            <TextField
              label="Kullanıcı adı"
              variant="standard"
              onChange={userNameHandler}
              fullWidth
              required
              sx={fieldSx}
            />
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 1 }}>
            <AlternateEmailIcon sx={{ color: alpha(ACCENT, 0.7), my: 0.5 }} />
            <TextField
              label="Email"
              variant="standard"
              onChange={emailHandler}
              type="email"
              fullWidth
              required
              sx={fieldSx}
            />
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 1 }}>
            <LockIcon sx={{ color: alpha(ACCENT, 0.7), my: 0.5 }} />
            <TextField
              label="Şifre"
              variant="standard"
              onChange={passwordHandler}
              type={showPassword ? 'text' : 'password'}
              fullWidth
              required
              sx={fieldSx}
            />
            <IconButton
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
              onMouseUp={handleMouseUpPassword}
              sx={{ color: alpha('#fff', 0.6) }}
            >
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </Box>

          <FormControl fullWidth variant="standard" sx={fieldSx}>
            <InputLabel id="new-user-role-label">Yetkisi</InputLabel>
            <Select
              labelId="new-user-role-label"
              value={role}
              label="Yetkisi"
              onChange={handleChange}
              MenuProps={{
                PaperProps: {
                  sx: {
                    bgcolor: '#0f172a',
                    border: `1px solid ${alpha(ACCENT, 0.2)}`,
                    '& .MuiMenuItem-root': { color: '#fff' },
                    '& .MuiMenuItem-root:hover': { bgcolor: alpha(ACCENT, 0.1) },
                  },
                },
              }}
            >
              <MenuItem value={'user'}>Kullanıcı</MenuItem>
              <MenuItem value={'admin'}>Yönetici</MenuItem>
            </Select>
          </FormControl>

          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mt: 1 }}>
            <Button
              onClick={() => canselHandler()}
              sx={{
                color: alpha('#fff', 0.7),
                textTransform: 'none',
                borderRadius: 2,
                px: 3,
                ':hover': {
                  background: alpha(ACCENT, 0.12),
                  color: ACCENT,
                },
              }}
            >
              İptal
            </Button>
            <Button
              variant="contained"
              onClick={() => newUserHandler()}
              sx={{
                bgcolor: ACCENT,
                color: '#000',
                fontWeight: 600,
                textTransform: 'none',
                borderRadius: 2,
                px: 3,
                ':hover': { bgcolor: '#059669' },
              }}
            >
              Oluştur
            </Button>
          </Box>
        </Box>
      </Paper>
    </Box>
  )
}

export default NewUser;
